var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox min-w-1400"},[_c('div',{staticClass:"imgBox1 min-w-1400"},[_c('div',{staticClass:"img1Box max-w-1400"},[_c('img',{staticClass:"imgItem1",attrs:{"src":_vm.$route.path !== '/' ? _vm.importedImg1 : _vm.importedImg2,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }